import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'components/Icon';
import {FormattedMessage} from 'react-intl';
import styles from './PFilterParsingError.css?module';

class PFilterParsingError extends React.Component {
  render() {
    if (!this.props.hasQuerystringError) return null;
    return (
      <div className={styles.container}>
        <div className={styles.messageContainer}>
          <div className={styles.title}>
            <Icon
              icon={Icon.OPTIONS.EXCLAMATION_TRIANGLE_OUTLINE}
              className={styles.iconWarn}
              size={Icon.SIZES.NANO}
            />
            <FormattedMessage
              id="PFilterParsingError__Title"
              description="Title for pfilter error."
              defaultMessage="Invalid PFilters"
            />
          </div>
          <div className={styles.description}>
            <FormattedMessage
              id="PFilterParsingError__Explanation"
              description="Error displayed when pfilters passed in via the url could not be parsed"
              defaultMessage={`The pfilters specified in the URL could not be parsed.`}
            />
          </div>
        </div>
        <div onClick={this.props.clearQueryStringError}>
          <Icon icon={Icon.OPTIONS.X} className={styles.dismissIcon} />
        </div>
      </div>
    );
  }
}

PFilterParsingError.propTypes = {
  clearQueryStringError: PropTypes.func.isRequired,
  hasQuerystringError: PropTypes.bool.isRequired,
};

export default PFilterParsingError;
